export const SYMPTOMS = {
  key: 'SYMPTOMS',
  value: 2,
  group: 1,
  title: 'health-record.conditions.symptom_title',
  menu_title: 'health-record.conditions.symptom_title',
  sub_title: 'Symptom',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Symptom-Checker.svg'),
  icon: 'file-check-outline',
  editor: 'ConditionEditor',
  message_translate: 'health-record.conditions.message',
  model_name: 'condition',
  resource: 'hr/symptom/',
  plain_resource: 'symptom',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.conditions.symptom',
      value: 'record.symptom',
    },
    {
      text: 'health-record.conditions.start-date',
      value: 'record.start_formatted',
    },
    {
      text: 'health-record.conditions.end-date',
      value: 'record.end_formatted',
    },
    {
      text: 'health-record.conditions.intensity',
      value: 'record.intensity',
    },
    {
      text: 'health-record.conditions.frequency',
      value: 'record.frequency.value',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      start_formatted: 'start',
      end_formatted: 'end',
      symptom: 'symptom',
      intensity: 'intensity',
      frequency: {
        value: 'frequency',
      },
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #ad1457 3.07%, #d81b60 100%)',
  color: '#D81B60',
  opaque: '#F3CDDB',
}
